import React from 'react';

export const EmployeeGenReleaseURL = ({ record }) => {
        var url = "/#/EmployeeGenReleases/"+record.id+":"+record.Position+"/show"
        return (
            <a href={encodeURI(url)}>Employee GenRelease Link</a>
        );
}

